module.exports = __webpack_public_path__ + "img/rond-rouge.1bd3b494.png";